import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IInitialState, RootState, getState } from '../../../../reduxService';
import { ISlopedGabionResults, ISteppedGabionResults, IVerticalDropsResults } from '../../api/IApiResponse';
import * as BeMaccaferriCalculationHelper from '../../api/calculation/BeMaccaferriCalculationHelper';
import { IProjectMacra2 } from './projectSlice';

const initialState: IInitialState<ISteppedGabionResults | ISlopedGabionResults | IVerticalDropsResults> = {
    initialState: true,
};

export const resultsSlice = createSlice({
    name: 'resultsMacra2',
    initialState,
    reducers: {
        cleanResults: state => {
            state.initialState = true;
            state.data = undefined;
        },
        setDesignImg: (state, action: PayloadAction<string>) => {
            if (!state.initialState) state.data!.channelDesignImg = action.payload;
        },
        setCrossSectionImg: (state, action: PayloadAction<string>) => {
            if (!state.initialState) state.data!.dischargeCurveImg = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchVerticalProjectResults.pending, state => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchVerticalProjectResults.fulfilled, (state, action) => {
                state.data = action.payload;
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchVerticalProjectResults.rejected, (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            })

            .addCase(fetchSteppedProjectResults.pending, state => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchSteppedProjectResults.fulfilled, (state, action) => {
                state.data = action.payload;
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchSteppedProjectResults.rejected, (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            })

            .addCase(fetchSlopedProjectResults.pending, state => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchSlopedProjectResults.fulfilled, (state, action) => {
                state.data = action.payload;
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchSlopedProjectResults.rejected, (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            });
    },
});

export const fetchVerticalProjectResults = createAsyncThunk('api/CalculationVerticalDrops/GetResultsMacra2Vertical', async (_undefined, { rejectWithValue }) => {
    try {
        const state: RootState = getState() as RootState;
        let response = await BeMaccaferriCalculationHelper.getVerticalResultsAsync(state.macra2.project.data!);
        return response.data as IVerticalDropsResults;
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});
export const fetchSteppedProjectResults = createAsyncThunk('api/CalculationStepped/GetResultsMacra2Stepped', async (_undefined, { rejectWithValue }) => {
    try {
        const state: RootState = getState() as RootState;
        let response = await BeMaccaferriCalculationHelper.getSteppedResultsAsync(state.macra2.project.data!);
        return response.data as ISteppedGabionResults;
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});
export const fetchSlopedProjectResults = createAsyncThunk('api/CalculationSloped/GetResultsMacra2Sloped', async (_undefined, { rejectWithValue }) => {
    try {
        const state: RootState = getState() as RootState;
        let response = await BeMaccaferriCalculationHelper.getSlopedResultsAsync(state.macra2.project.data!);
        return response.data as ISlopedGabionResults;
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});

export const { cleanResults, setDesignImg, setCrossSectionImg } = resultsSlice.actions;

export default resultsSlice.reducer;
